const translations = {
  en: {
    navbar: {
      title: "Ratio",
	  homePage: "Home",
	  aboutPage: "About",
	  adminPage: "Admin",
      debateArenas: "DebateArena",
      leaderboard: "Leaderboard",
      trainingMode: "Training Mode",
	  notifications: "Notifications",
      contact: "Contact",
	  profile: "Profile",
      signup: "Sign Up",
	  login: "Login",
      greetings: "Welcome",
	  logout: "Logout",
	  loading: "Loading"
    },
    hero: {
      title: "Reason. Debate. Win.",
      subtitle: "Join the most competitive intellectual platform.",
      joinDebate: "Join a Debate",
      createArena: "Create an Arena"
    },
    featuredDebates: {
      title: "Featured Debates",
      joinNow: "Join Now",
      loading: "Loading debates..."
    },
    trendingTopics: {
      title: "Trending Topics",
      loading: "Loading trending topics..."
    },
    footer: {
      copyright: "Ratio. All Rights Reserved."
    },
    login: {
      greetings: "Welcome",
	  login: "Login",
	  logout: "Logout",
	  password: "Password:",
	  email: "Username/Email:",
	  loginwithg: "Login with Google"
    },
    signup: {
      signup: "Sign Up",
	  login: "Login",
	  logout: "Logout",
	  name: "Username",
	  password: "Password:",
	  email: "Email:",
	  loginwithg: "Login with Google"
    },
    debates: {
      debatearenas: "Debate Arenas",
	  debatejoin: "Explore and join live debates."
    },
	createdebates: {
      newdebate: "Create a New Debate",
	  selectdebate: "Select a debate format and invite participants."
    },
	profile: {
      loginmessage: "You must be logged in to view this page.",
	  title: "Profile",
	  name: "Username:",
	  bio: "Bio:",
	  nobio: "No bio yet.",
	  pref: "Preferred Topics:",
	  editpref: "Preferred Topics (comma-separated):",
	  editpro: "Edit Profile",
	  nopref: "No preferred topics.",
	  loading: "Loading user stats...",
	  email: "Email:",
	  joined: "Joined:",
	  ranking: "Elo Ranking:",
	  tdebates: "Total Debates:",
	  wins: "Wins:",
	  losses: "Losses:",
	  savechanges: "Save Changes",
	  cancelchanges: "Cancel",
	  pprivacy: "Privacy Settings",
	  pv: "Profile Visibility:",
	  bv: "Bio Visibility:",
	  tv: "Topics Visibility:",
	  dsv: "Debate Stats Visibility:",
	  public_v: "Public",
	  private_v: "Private",
	  followers_v: "Followers:",
	  following_v: "Following:",
	  followers_only: "Followers Only",
	  bioprivate: "Bio is private.",
	  ptopicprivate: "Preferred topics are private.",
	  privateuser: "This profile is private. Follow to view more details."
	  
    },
	leadersboard: {
      title: "Leaderboard",
	  details: "See top-ranked debaters.",
	  ranking: "Elo Ranking",
	  tdebates: "Total Debates",
	  loading: "Loading top-ranked debaters...",
	  name: "Name",
	  number: "No."
    },
	faq: {
      title: "Frequently Asked Questions",
	  details: "Find answers to common questions."
    },
	livedebates: {
      title: "Live Debates",
	  details: "Explore and join live debates."
    },
	contactus: {
      title: "Contact Us",
	  details: "About Our things"
    },
	training: {
      title: "Training Page",
	  details: "See top-ranked debaters."
    },
	components: {
	  follow: "Follow",
	  unfollow: "Unfollow"
	},  
	debateroom: {
	  debateArena: "Debate Arena",
	  upload: "Upload",
	  uploadPlaceholder: "Select an audio or video file...",
	  uploading: "Uploading...",
	  debateRoom: "Debate Room",
    },
	messages: {
	  uploadedAt: "Uploaded at"
	}
  }
};

export default translations;
